
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados do local de retira</span>
        </v-card-title>
        <v-card-text>
          <PickupLocationForm ref="form" :pickup_location="pickup_location"></PickupLocationForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog">Cancelar</f-btn>
          <f-btn save @click="updatePickupLocation">Salvar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogEditPickupLocation',
  components: {
    PickupLocationForm: () => import('@/_backoffice/_registrations/components/pickup_locations/forms/PickupLocationForm.vue'),
  },
  props: {
    model_pickup_location: {
      type: Object,
      required: true,
    },
    dialog:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      pickup_location: {}
    }
  },
  methods: {
    setPickupLocation(){
      this.pickup_location = JSON.parse(JSON.stringify(this.model_pickup_location))
    },
    closeDialog(){
      this.$emit('closeDialog', 'pickup_location')
    },  
    updatePickupLocation() {
      if(this.$refs.form.validate()){
        this.saving = true
        let { name, CNPJ, id } = this.pickup_location
        let pickup_location = {name, CNPJ, id}
        Api.PickupLocation.update(pickup_location).then(r=> r.data).then(d=> {
          this.successUpdated()
          this.$emit('updated', 'pickup_location')
        }).catch(err=>{
          console.log(err)
          this.errorUpdated()
        }).finally(() => {
          this.saving = false
          this.closeDialog()
        })
      }
    },
  },
  mounted () {
    this.setPickupLocation();
  },
}
</script>